import { DateTime } from 'luxon';
import { ZONA_OPERATIVA } from '../tipos/comunes.js';
import { contiene } from './rango.js';
/**
 * Horarios semanales → ventanas absolutas.
 *
 * Todo el motor trabaja en UTC. Los horarios, en cambio, estan escritos en hora
 * local ("los martes de 08:00 a 12:00") y esa hora local depende de la zona
 * operativa. Convertir con `Date` cruda seria correcto solo hasta el primer
 * cambio de huso o de fecha de horario de verano; por eso se usa Luxon.
 */
function minutosDeHHMM(hhmm) {
    const [h, m] = hhmm.split(':');
    const horas = Number(h);
    const minutos = Number(m ?? 0);
    if (!Number.isFinite(horas) || !Number.isFinite(minutos)) {
        throw new Error(`Hora invalida en el horario del recurso: ${hhmm}`);
    }
    return horas * 60 + minutos;
}
/** Convierte `diaSemana` de Postgres (0 = domingo) al de Luxon (7 = domingo). */
function aDiaLuxon(diaSemana) {
    return diaSemana === 0 ? 7 : diaSemana;
}
/**
 * Ventanas absolutas de trabajo del recurso que tocan el rango pedido.
 * Devuelve los intervalos ya fusionados: dos ventanas contiguas —22:00–24:00 y
 * 00:00–02:00 del dia siguiente— quedan como una sola, que es lo que permite
 * que un servicio cruce la medianoche sin caerse.
 */
export function ventanasDeTrabajo(horarios, rango, zona = ZONA_OPERATIVA) {
    if (horarios.length === 0)
        return [];
    const desdeLocal = DateTime.fromJSDate(rango.inicio, { zone: zona }).startOf('day');
    const hastaLocal = DateTime.fromJSDate(rango.fin, { zone: zona }).startOf('day');
    const ventanas = [];
    // Un dia antes y uno despues: cubre los servicios que cruzan la medianoche.
    for (let dia = desdeLocal.minus({ days: 1 }); dia <= hastaLocal.plus({ days: 1 }); dia = dia.plus({ days: 1 })) {
        for (const horario of horarios) {
            if (aDiaLuxon(horario.diaSemana) !== dia.weekday)
                continue;
            const inicio = dia.plus({ minutes: minutosDeHHMM(horario.desde) });
            const fin = dia.plus({ minutes: minutosDeHHMM(horario.hasta) });
            if (fin <= inicio)
                continue;
            ventanas.push({ inicio: inicio.toJSDate(), fin: fin.toJSDate() });
        }
    }
    return fusionar(ventanas);
}
/** Une intervalos que se tocan o se solapan. Espera y devuelve rangos ordenados. */
export function fusionar(rangos) {
    const ordenados = [...rangos].sort((a, b) => a.inicio.getTime() - b.inicio.getTime());
    const fusionados = [];
    for (const actual of ordenados) {
        const ultimo = fusionados[fusionados.length - 1];
        if (ultimo && actual.inicio.getTime() <= ultimo.fin.getTime()) {
            if (actual.fin.getTime() > ultimo.fin.getTime()) {
                fusionados[fusionados.length - 1] = { inicio: ultimo.inicio, fin: actual.fin };
            }
        }
        else {
            fusionados.push({ inicio: actual.inicio, fin: actual.fin });
        }
    }
    return fusionados;
}
/** El rango entra entero dentro de alguna ventana de trabajo del recurso. */
export function dentroDeHorario(horarios, rango, zona = ZONA_OPERATIVA) {
    return ventanasDeTrabajo(horarios, rango, zona).some((ventana) => contiene(ventana, rango));
}
//# sourceMappingURL=horario.js.map